export default "__VITE_ASSET__263119be__"